import React from 'react'
import styles from '../../styles/main.module.css'

function Advert() {
  return (
    <div className={`${styles.AdvertStyleMob}`}>
      <span className='w-100'>
        <div className={`${styles.AdvertStyleTop} d-lg-flex`}></div>
      </span>
      <a href="https://www.chaniabank.gr/omilos/eteriki-kinoniki-efthyni/kinonia/digital-school/" target="_blank" rel="noopener noreferrer" className="w-100">
        <div className={`${styles.AdvertStyle} d-lg-flex`}></div>
      </a>
    </div>
    
  )
}

export default Advert